import { render, staticRenderFns } from "./PicSettingWidget.vue?vue&type=template&id=368f4578&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./PicSettingWidget.vue?vue&type=script&lang=js&"
export * from "./PicSettingWidget.vue?vue&type=script&lang=js&"
import style0 from "./PicSettingWidget.vue?vue&type=style&index=0&id=368f4578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368f4578",
  null
  
)

export default component.exports